import api from './api';

export interface TaskCost {
  task_type: string;
  cost_in_credits: number;
  is_active: boolean;
}

const taskCostService = {
  getTaskCost: async (taskType: string): Promise<TaskCost> => {
    const response = await api.get<TaskCost>(`/ai-task-costs/${taskType}`);
    return response.data;
  },

  getAllTaskCosts: async (): Promise<TaskCost[]> => {
    const response = await api.get<TaskCost[]>('/ai-task-costs');
    return response.data;
  },
};

export default taskCostService;